<div class="favorites-list-box">
  @if (dataSource) {
    <dx-list
      #dxList
      [dataSource]="dataSource"
      [grouped]="true"
      [collapsibleGroups]="true"
      [hoverStateEnabled]="false"
      [searchEnabled]="true"
      [searchMode]="sreachModeList"
      [selectionMode]="selectionModeList"
      (onContentReady)="contentReady($event)"
      (onItemClick)="itemClicked($event)"
      [noDataText]="dataService.res('Favorites-No-Data')"
    >
      <dxo-search-editor-options
        placeholder="{{ dataService.res('Favorites-Search') }}"
      >
      </dxo-search-editor-options>
      <div *dxTemplate="let item of 'item'">
        <div matTooltip="{{ item['DisplayText'] }}" matTooltipPosition="above">
          {{ item["DisplayText"] || "" }}
        </div>
      </div>
    </dx-list>
  }

  <div class="loader-container">
    <dx-load-indicator [visible]="showLoader"></dx-load-indicator>
  </div>
</div>
